import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type YamarketProductSettings as SchemaYamarketProductSettings } from '../schemas/YamarketProductSettings';
import { type YandexMarketCampaignRequest as SchemaYandexMarketCampaignRequest } from '../schemas/YandexMarketCampaignRequest';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Integrations
 */
export const UpdateYandexMarketProductsSettingsContentType = 'application/json' as const;
export type UpdateYandexMarketProductsSettingsRequest = SchemaYandexMarketCampaignRequest;
export type UpdateYandexMarketProductsSettingsResponses = LinkCommonErrorResponses & {
    '200': {
        'application/json': SchemaYamarketProductSettings;
    };
};
export type UpdateYandexMarketProductsSettingsResponseSuccess =
    UpdateYandexMarketProductsSettingsResponses['200']['application/json'];
export type UpdateYandexMarketProductsSettingsSearchParams = undefined;
export type UpdateYandexMarketProductsSettingsPathParameters = undefined;
export const UpdateYandexMarketProductsSettingsUrl = '/integrations/settings/products/yamarket' as const;
export const UpdateYandexMarketProductsSettingsMethod = 'POST' as const;
export const getUpdateYandexMarketProductsSettingsUrl = (_params?: UpdateYandexMarketProductsSettingsPathParameters) =>
    UpdateYandexMarketProductsSettingsUrl;
